import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AuftragRubrikSelectionMeta } from 'app/core/batch-auftrag-api';
import { AtLeastOneValidatorDirective } from '../../validators/at-least-one-validator.directive';
import { CapFormControlComponent } from '../../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-auftrag-rubrik-selection',
  templateUrl: './auftrag-rubrik-selection.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragRubrikSelectionComponent),
      multi: true
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ],
  imports: [
    AtLeastOneValidatorDirective,
    FormsModule,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class AuftragRubrikSelectionComponent implements ControlValueAccessor {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input()
  disabled: boolean;

  model: AuftragRubrikSelectionMeta;

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {
    keysToTranslate<string>([
      'EingabeMussMindestensEineRubrikAusgewaehltHaben', // same name as ngModelGroup of template
      'VonAenderungenBetroffeneRubriken',
      'amtlicheBewertung'
    ]);
  }

  writeValue(obj: AuftragRubrikSelectionMeta): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
